import { Accomodation, EventSinglePage, Place } from "@/types";

import routeicon from "@/assets/routicon_colored.svg";
import phone from "@/assets/phone_colored.svg";
import global from "@/assets/global-colored.svg";
import calendar from "@/assets/calendar.svg";
import mail from "@/assets/mail.svg";
import formatDateToGreek from "@/utils/formatDateToGreek";
import InfoBlock from "@/components/InfoBlock";
import { motion } from "framer-motion";
import { tabVariantsAnimation } from "@/theme/theme";

const Info: React.FC<EventSinglePage> = ({ event }) => {
    const { data } = event;

    return (
        data && (
            <motion.div
                variants={tabVariantsAnimation}
                animate="animate"
                initial="initial"
                className="space-y-10"
            >
                <div className="grid grid-cols-5 gap-4 items-start">
                    <div className="col-span-5 lg:col-span-3 space-y-6">
                        <InfoBlock data={data} />

                        <div
                            dangerouslySetInnerHTML={{ __html: data?.content }}
                        />
                    </div>
                    <img
                        className="col-span-5 lg:col-span-2 mt-0"
                        src={data.image}
                    />
                </div>
            </motion.div>
        )
    );
};

export default Info;
